/* Package JSON Import will be here */
import React from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { getTranslate } from "react-localize-redux";
/* Package JSON Import will be here */

/* Project Import will be here */
import { getCurrentPageTitle } from "utilities/utils";
/* Project Import will be here */

const DocumentPageTitle = (props) => {
    const { translate } = useSelector((state) => ({
        translate: getTranslate(state.locale)
    }));
    return (
        /* Set page title */
        <Helmet><title>{getCurrentPageTitle(props.location.pathname, window.enableQueryStringToken ? false : true, translate)}</title></Helmet>
    );
};

export default DocumentPageTitle;